import React from "react";
import { Link } from "redux-little-router";
import AccordionItem from "../common/AccordionItem";
import { Card } from "luna-react/components/card";
import { marketingPermissionsUrl } from "../../config";

export default () => {
  return (
    <Card className="faq__wrapper">
      <div className="section_header center-text">
        <h1 className="section_title">FAQ</h1>
        <span className="section_subtext">
          Click on one of the most frequently asked, data related, questions
          below
        </span>
      </div>

      {faqContent.map(({ title, content }, index) => (
        <AccordionItem key={index} title={title}>
          {content}
        </AccordionItem>
      ))}
    </Card>
  );
};

export const faqContent = [
  {
    title: "Can I access the personal data you hold about me?",
    content: (
      <div>
        <p>
          Yes, you can ask us for a copy of the personal data we hold about you.
          Please send your request to{" "}
          <a href="mailto:privacy@sainsburys.co.uk">privacy@sainsburys.co.uk</a>{" "}
          or write to the Data Protection Officer at Privacy Team, Sainsbury's
          Supermarkets Ltd, 18th Floor, Arndale House, Manchester, M4 3AL.
        </p>
        <p>
          Before we send you a copy of your personal data or carry out a
          request, we'll need to confirm your identity. This allows us to
          protect customers' confidentiality and stop personal data falling into
          the wrong hands. To confirm who you are we may need copies of some
          identification documents, such as your passport or utility bills.
        </p>
      </div>
    ),
  },
  {
    title: "How do I request CCTV images from one of your stores?",
    content: (
      <div>
        <div>
          If you want to request CCTV of yourself from our stores please send
          your request to{" "}
          <a href="mailto:privacy@sainsburys.co.uk">privacy@sainsburys.co.uk</a>{" "}
          or write to the Data Protection Officer at Privacy Team, Sainsbury's
          Supermarkets Ltd, 18th Floor, Arndale House, Manchester, M4 3AL.
        </div>
        <div>
          We might ask you for more information to help us identify you within
          the CCTV footage. We keep CCTV footage for up to 31 days, after that
          it's deleted.
        </div>
      </div>
    ),
  },
  {
    title: "How will you send my personal data to me?",
    content: (
      <div>
        <p>We can send you your personal data in a couple of ways:</p>
        <ul>
          <li>
            <strong>Via encrypted email:</strong> Your personal data will be
            encrypted with a password to protect your confidentiality. You’ll
            get the password separately via a text message, or a separate email
            if you don’t have a mobile phone.
          </li>
          <li>
            <strong>By post:</strong> We can also send your personal data to
            your confirmed address. Anything we send by post will be sent
            recorded delivery.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "How do I get personal data that Nectar hold about me?",
    content: (
      <div>
        Please send your request to{" "}
        <a
          title="privacy@sainsburys.co.uk"
          href="mailto:privacy@sainsburys.co.uk"
        >
          privacy@sainsburys.co.uk
        </a>{" "}
        or write to the Data Protection Officer at Privacy Team, Sainsbury's
        Supermarkets Ltd, 18th Floor, Arndale House, Manchester, M4 3AL.
      </div>
    ),
  },
  {
    title: "Who do you share my data with?",
    content: (
      <div>
        <p>
          We only share your data with Sainsbury’s Group and with trusted third
          parties. For more information see our{" "}
          <Link href="/privacy-policy">Privacy Policy</Link>.
        </p>
      </div>
    ),
  },
  {
    title: "Why do you keep my data for a certain length of time?",
    content: (
      <div>
        <p>
          We never hang on to your personal data for longer than we need to. We
          only keep it for the purposes in accordance with our privacy policy
          and in accordance with the law and relevant regulations. For more
          information see our <Link href="/privacy-policy">Privacy Policy</Link>
          .
        </p>
      </div>
    ),
  },
  {
    title: "How can I opt out of receiving marketing?",
    content: (
      <div>
        <p>
          If you want to opt out from Sainsbury’s Group marketing, visit our{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={marketingPermissionsUrl}
          >
            Group Marketing Permissions Centre
          </a>
          . That’s where you can tell us which services you wish to hear from
          and which ones to stop hearing from. You can also call us on{" "}
          <a href="tel:0800636262">0800 63 62 62</a> to update your marketing
          choices.
        </p>
        <p>
          Please note that once you opt out, we’ll stop sending you marketing
          communications &amp; offers.
        </p>
      </div>
    ),
  },
  {
    title: "How do I change my Nectar marketing permissions?",
    content: (
      <div>
        <p>You can manage your Nectar permissions:</p>
        <ul>
          <li>
            In the{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={marketingPermissionsUrl}
            >
              Group Marketing Permissions Centre
            </a>{" "}
            by ticking/un-ticking the Nectar box
          </li>
          <li>Visit your Nectar online account</li>
        </ul>
      </div>
    ),
  },
  {
    title:
      "I don’t remember giving permissions directly to Sainsbury’s Group companies. Is there any other way I could have been opted in/out of Sainsbury’s Group marketing communication?",
    content: (
      <div>
        <p>
          Sainsbury’s, Sainsbury’s Financial Services, Tu Clothing and Argos are
          all members of Nectar Loyalty Scheme. When you register with Nectar
          you may allow Nectar to send you marketing about its partners. So, if
          you allowed Nectar and its partners to communicate with you in the
          past, they’ll be able to talk to you about these partner companies.
        </p>
        <p>
          If you want to change any marketing permissions, visit the{" "}
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={marketingPermissionsUrl}
          >
            Group Marketing Permissions Centre
          </a>{" "}
          and un-tick the companies you don’t want to hear from. This will
          override any Nectar marketing permissions relating to the companies
          you un-tick, and you’ll stop hearing from them.
        </p>
      </div>
    ),
  },
  {
    title: "How can I get in touch with the Data Protection Officer?",
    content: (
      <div>
        <p>
          You can contact the Data Protection Officer by emailing{" "}
          <a href="mailto:privacy@sainsburys.co.uk">privacy@sainsburys.co.uk</a>{" "}
          or write to the Data Protection Officer at Privacy Team, Sainsbury's
          Supermarkets Ltd, 18th Floor, Arndale House, Manchester, M4 3AL.
        </p>
      </div>
    ),
  },
];



// WEBPACK FOOTER //
// ./src/components/pages/FAQ.js